module.exports = __webpack_public_path__ + "media/components/sessions/email-verification/img/open-mail-58a8ba8ad7f10dc3896da852c4d5fa49.svg";